import { render } from "./LogoutMain.vue?vue&type=template&id=f2f15b92&scoped=true"
import script from "./LogoutMain.vue?vue&type=script&lang=js"
export * from "./LogoutMain.vue?vue&type=script&lang=js"

import "./LogoutMain.vue?vue&type=style&index=0&id=f2f15b92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f15b92"]])

export default __exports__